import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { NotificationItem } from 'src/app/models/domain';
import { YPMNOTIFICATIONSRVItems } from 'src/generated-clients/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationItemAdapter implements IAdapter<
  NotificationItem,
  YPMNOTIFICATIONSRVItems
> {
  public adaptToDomain(item: YPMNOTIFICATIONSRVItems): NotificationItem {
    return new NotificationItem(
      fallbackString(item.notificationNumber),
      fallbackString(item.itemNumber),
      fallbackString(item.equipmentNumber),
      fallbackString(item.sortNumber),
      fallbackString(item.catalogType),
      fallbackString(item.codeGroup),
      fallbackString(item.partOfObject),
      fallbackDate(item.createdDate),
      item.longTextAvailable === 'X',
      fallbackString(item.createdBy),
      fallbackString(item.shortText),
      fallbackString(item.causeShortText),
      fallbackString(item.longTextLines),
      fallbackString(item.longTextName),
      fallbackString(item.longText)
    );
  }
}
